import React from 'react'
import styled from '@emotion/styled'
import { object } from 'prop-types'

// Import Components
import { Breadcrumbs } from '../Breadcrumbs'
import { ContentSocialBlock } from '../ContentSocialBlock'

// Breadcrumb
const ToolBarWrapper = styled.div`
	background: ${({ theme }) => theme.colors.lightGrey};
	display: block;
	height: 50px;
	width: 100%;

	${({ theme }) => theme.MQ.M} {
		position: relative;
	}
`
const ToolBar = styled.div`
	${({ theme }) => theme.maxWidth.L};
	display: flex;
	height: inherit;
	margin: auto;

	${({ theme }) => theme.MQ.M} {
		align-items: center;
		justify-content: space-between;
	}
`
const BreadcrumbsWrapper = styled.div`
	margin: auto;
	width: 90%;
	font-size: 12px;

	${({ theme }) => theme.MQ.S} {
		margin: auto 0 auto 23px;
		width: 98%;
		font-size: 16px;
	}
	${({ theme }) => theme.MQ.XL} {
		margin: auto 0;
	}
`
const SocialBlockWrapper = styled.div`
	display: none;

	${({ theme }) => theme.MQ.M} {
		margin: 0 30px 0 auto;
		max-width: 250px;
		display: inline-block;
	}

	${({ theme }) => theme.MQ.XL} {
		margin: auto;
	}
`

ContentToolBar.propTypes = {
	breadcrumbs: object.isRequired,
}

export function ContentToolBar({ breadcrumbs, canonical, title }) {
	return (
		<ToolBarWrapper>
			<ToolBar>
				<BreadcrumbsWrapper>
					<Breadcrumbs breadcrumbs={breadcrumbs} />
				</BreadcrumbsWrapper>
				<SocialBlockWrapper>
					<ContentSocialBlock canonical={canonical} showShareThis={false} title={title} />
				</SocialBlockWrapper>
			</ToolBar>
		</ToolBarWrapper>
	)
}
